import { API } from "../apis/apiService";

// Single source of truth for "who is logged in": the API, not localStorage.
// `sso/session-user` authenticates from the HttpOnly session cookie / bearer
// token and returns the user as the server knows them, so the id and role can't
// be changed from the browser console.
export const fetchCurrentUser = async () => {
  const res = await API.get("sso/session-user");
  const user = res.data?.user;
  if (!res.data?.status || !user) {
    throw new Error("No active session");
  }
  return { ...user, id: user.id ?? user.user_id };
};
